import {
  type ExtraFieldCondition,
  type Scalars,
} from "@package/ui-gql/index-data-access";
import { get } from "lodash";

export function getConditionTypeValue(
  condition: ExtraFieldCondition,
): string | boolean | number | null {
  switch (condition.value.__typename) {
    case "ConditionValueTypeBoolean": {
      return condition.value.valueBoolean;
    }
    case "ConditionValueTypeString": {
      return condition.value.valueString;
    }
    case "ConditionValueTypeNumber": {
      return condition.value.valueNumber;
    }
    default:
      return null;
  }
}

export function isConditionFalsey(
  condition: ExtraFieldCondition,
  data?: Scalars["JSONObject"]["output"],
): boolean {
  return get(data, condition.field) !== getConditionTypeValue(condition);
}
